import classNames from 'classnames'
import { useField } from 'formik'
import React from 'react'
import { toast } from 'react-toastify'
import BaseSelect from 'shared/components/base/form/base-select'
import { BaseLabelProps } from 'shared/components/base/form/BaseLabel'
import FetchData from 'shared/components/FetchData'
import dictionary from 'shared/constants/dictionary'
import { useEmit } from 'shared/contexts/socket/socket-context'

export type LeadSourceProps = {
  name: string
  value?: number
  label?: string
  selectClassName?: string
  labelProps?: BaseLabelProps
}
const textClassName =
  '!font-normal !text-[14px] !leading-[32px] !text-color-title '

export const LeadSourceFormik = (props: LeadSourceProps) => {
  const {
    value,
    name,
    labelProps,
    selectClassName,
    label = 'نحوه آشنایی',
  } = props
  const emit = useEmit()
  const [field, , meta] = useField({ name, value })
  const sortSources = (items: { label: string; value: number }[]) => {
    const importantKeys = [
      'سایت شرکت',
      'بیلبورد',
      'دوستان و همکاران',
      'اینستاگرام',
      'تلگرام',
      'عدم پاسخ',
    ]
    return items.sort((item) => (importantKeys.includes(item.label) ? -1 : 1))
  }
  const fetchLeadSourceOptions = async () => {
    return await emit('lead-source')
      .then((leadSources: { label: string; value: number }[]) => {
        const sortedSources = sortSources(leadSources)
        return sortedSources.map((leadSource) => ({
          ...leadSource,
          key: leadSource.value,
        }))
      })
      .catch(() => {
        toast.error(dictionary.socket_timeout)
      })
  }
  return (
    <FetchData
      request={fetchLeadSourceOptions}
      deps={[]}
      handleLoading={false}
      handleEmptyData={false}
    >
      {(leadSources) => {
        return (
          <>
            <BaseSelect<number>
              label={label}
              labelProps={labelProps}
              options={leadSources}
              className={classNames(selectClassName, '!h-full ')}
              onSelect={(value) => {
                meta.setValue(value)
              }}
              value={field?.value}
              isLoading={!leadSources?.length}
              setInputClassName={() => classNames(textClassName)}
            />
          </>
        )
      }}
    </FetchData>
  )
}
